/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Tooltip } from '@mui/material';

import { Namespaces } from '../../i18n';
import { usePlanCardStyles } from './PlanCard.styles';

export type PlanCardProps = {
  className?: string;
  amount: string | number;
  displayAmount?: boolean;
  currency: string;
  name: string;
  type: string;
  bottomTip?: string;
};

export function PlanCard(props: PlanCardProps) {
  const { t } = useTranslation([Namespaces.Common]);
  const { className, amount, name, type, bottomTip, displayAmount = true, currency } = props;
  const classes = usePlanCardStyles();
  return (
    <Card
      className={cx(className, {
        [classes.descriptionOnly]: !displayAmount,
      })}
      classes={{ root: classes.root }}
    >
      {displayAmount && (
        <div className={classes.price}>
          <span className={classes.priceAmount}>{t('format_currency.currencyShort', { value: amount, currency })}</span>
          <span className={classes.priceDuration}>/hour</span>
        </div>
      )}
      <div className={classes.description}>
        <div className={classes.name}>{name}</div>
        <div className={classes.type}>{type}</div>
      </div>
      {bottomTip && (
        <Tooltip title={bottomTip}>
          <div className={classes.bottomTip}>{bottomTip}</div>
        </Tooltip>
      )}
    </Card>
  );
}
